import TokenController from './tokenStorage';
import { decryptUserInfo } from './encryption';

export const getUserInfo = () => {
  const token = TokenController.get();
  if (!token) return null;
  return decryptUserInfo(token);
};
